module.exports = __webpack_public_path__ + "img/bianji.8cf9dc74.png";